import { useQuery } from '@tanstack/react-query';
import { fetchCdfBulkDownloadSummary } from '@/integrations/mtrManager/client';
import type { MtrBulkScope } from '@/hooks/useCollectsApiData';
import { useMtrBulkFilter } from '@/hooks/useMtrBulkFilter';
import type { FilterState } from '@/hooks/useFilters';
import { withTotalCollects, type CdfBulkDownloadSummaryView } from '@/services/mtrBulkFilter';

/**
 * Resumo do download em massa de CDFs. `total_cdfs` é deduplicado por certificado — um CDF
 * cobre várias coletas. Mesmo filtro resolvido do lote de MTR. Só dispara quando `enabled`.
 */
export function useCdfBulkDownloadSummary(
  filters: FilterState,
  enabled: boolean,
  scope: MtrBulkScope = 'historico',
) {
  const resolved = useMtrBulkFilter(filters, scope, enabled);

  const summary = useQuery<CdfBulkDownloadSummaryView>({
    queryKey: ['cdf-bulk-summary', resolved.data?.filter],
    queryFn: async () =>
      withTotalCollects(await fetchCdfBulkDownloadSummary(resolved.data!.filter), resolved.data!.totalCollects),
    enabled: enabled && !!resolved.data,
  });

  return {
    data: summary.data,
    isLoading: resolved.isLoading || summary.isLoading,
    isError: resolved.isError || summary.isError,
    refetch: () => (resolved.isError ? resolved.refetch() : summary.refetch()),
  };
}
